import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '../styles/App.scss';
import BottomNav from './BottomNav';
import Home from '../pages/Home';
import Dictionary from '../pages/Dictionary';
import DictionaryCategory from '../pages/DictionaryCategory';
import Cards from '../pages/Cards';
import Subscription from '../pages/Subscription';
import Account from '../pages/Account';
import Grammar from '../pages/Grammar';
import Combinations from '../pages/Combinations';
import Travel from '../pages/Travel';
import AI from '../pages/AI';
import { NotificationProvider } from './NotificationProvider';
import { postData } from '../utils/api';

function App() {
  useEffect(() => {
    const authTelegram = async () => {
      try {
        await postData('/auth/telegram', {});
      } catch (error) {
        console.error('Ошибка при авторизации через Telegram:', error);
      }
    };

    authTelegram();
  }, []);

  return (
    <NotificationProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dictionary" element={<Dictionary />} />
          <Route path="/dictionary/category/:categoryId" element={<DictionaryCategory />} />
          <Route path="/cards" element={<Cards />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/account" element={<Account />} />
          <Route path="/grammar" element={<Grammar />} />
          <Route path="/combinations" element={<Combinations />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/ai" element={<AI />} />
        </Routes>
        <BottomNav />
      </Router>
    </NotificationProvider>
  );
}
export default App;
